import * as React from 'react'
import * as PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Rule } from 'glamor'

import { withTheme, IWithThemeProps } from '../../theme'

import { Flex } from '../flex'
import { Button } from '../button'
import { Heading } from '../heading'
import { Paragraph } from '../paragraph'

import Satelite from './satelite.svg'

export interface IGlobalErrorBoundaryProps {
  children?: React.ReactNode
  style?: Rule
  displayErrors?: boolean
  onError?: (error: Error) => void
}

interface IGlobalErrorBoundaryState {
  error: Error | null
}

export const GlobalErrorBoundary = withTheme(
  class GlobalErrorBoundary extends React.Component<
    IGlobalErrorBoundaryProps & IWithThemeProps,
    IGlobalErrorBoundaryState
  > {
    static propTypes = {
      children: PropTypes.node,
      style: PropTypes.object,
      displayErrors: PropTypes.bool,
      onError: PropTypes.func,
    }

    state: IGlobalErrorBoundaryState = { error: null }

    componentDidCatch(error: Error) {
      this.setState({ error })
      if (this.props.onError) {
        this.props.onError(error)
      }
    }

    render() {
      return this.state.error ? (
        <Flex
          alignContent="center"
          alignItems="center"
          justifyContent="center"
          style={[
            {
              padding: `${this.props.theme.settings.spacing.large} ${this.props.theme.settings.spacing.large} 10vh`,
              height: '100vh',
              width: '100vw',
            },
            this.props.style,
          ]}
        >
          <Paragraph>
            <Satelite width={120} />
          </Paragraph>
          <Heading level="h1" variant="dim">
            <FormattedMessage defaultMessage="Oooops!" id="errorboundary.title" />
          </Heading>
          <Paragraph variant="dim">
            <FormattedMessage
              defaultMessage="Dooer crashed. Please contact our support if this happens again, we'll try to fix it asap."
              id="errorboundary.subtitle"
            />
          </Paragraph>
          {this.props.displayErrors ? (
            <Flex style={{ textAlign: 'left', marginBottom: this.props.theme.settings.spacing.large }}>
              <pre>{this.state.error.stack}</pre>
            </Flex>
          ) : null}
          <Flex row>
            <Button
              flush
              onClick={() => {
                window.history.go(-1)
                setTimeout(() => window.location.reload(true), 100)
              }}
              style={{ marginRight: this.props.theme.settings.spacing.small }}
            >
              <FormattedMessage defaultMessage="Go back" id="errorboundary.back" />
            </Button>
          </Flex>
        </Flex>
      ) : (
        this.props.children || null
      )
    }
  }
)
